import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import Select from "react-select";

import ReactDatetime from "react-datetime";

import moment from "moment";
import jsPDF from "jspdf";

import NotificationAlert from "react-notification-alert";
import { MDBInput } from "mdb-react-ui-kit";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip,
  Progress,
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";

import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import DatePicker from "../../components/DatePicker/Datepicker.js";
import { withRouter } from "react-router-dom";

import {
  Whatsapp_CAMPAIGN_REPORTS,
  WHATSAPP_CAMPAIGN_LIST_DATE,
  CAMPAIGN_LIST,
  CAMPAIGN_LIST_BY_CAMPAGIN,
  CAMPAIGN_LIST_BY_CAMPAGIN_STATUS_EXCEL
} from "../../constants.js";
import axios from "axios";

import LoadingScreen from "react-loading-screen";
//import logo from "../../../assets/img/logo.png";
import logo from "../../assets/img/logo.png";

let templates = [];
let senderids = [];
let campaigns = [];
const localJson = localStorage.getItem("user");
const user = JSON.parse(localJson);
let datacount =[]
const CampaignReports = (props) => {
 
  const [campaignList, setCampaginList] = useState([]);
  const [graph, setGraph] = useState([]);

  const [isLoading, setIsLoading] = React.useState(false);
  const [errorhandle, setErrorHandle] = useState();
  const notificationAlertRef = React.useRef(null);

  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    senderid: "",
  });
  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });

  const [startedOn, setStartedOn] = useState({ sdate: "", stime: "", tname:"" });

  const downloadCampaignDetails = async () => {
  try {
    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);

    const payload = {
      tname: startedOn?.tname,
      sdate: startedOn?.sdate,
      senderid: user?.sender_id
    };
    setIsLoading(true);
    const res = await axios.post(CAMPAIGN_LIST_BY_CAMPAGIN_STATUS_EXCEL, payload);
    setIsLoading(false);
    const data = res?.data?.message;

    if (!data || data.length === 0) {
      alert("No data available");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Campaign Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    });

    saveAs(
      blob,
      `campaign_${startedOn?.tname}_${startedOn?.sdate}.xlsx`
    );

  } catch (err) {
    console.error(err);
    alert("Download failed");
  }
};

 const fetchgraph=(date,tname,stime)=>{
  datacount = []
  let fromdate = moment(date).format("YYYY-MM-DD");
 

  let lclstrg = localStorage.getItem("user");
  let user = JSON.parse(lclstrg);

  const payload = {
    date: fromdate,
    senderid: user.sender_id,
    tname:tname
    
  };

  // ✅ SET STARTED ON HERE
  setStartedOn({ sdate: date, stime: stime, tname:tname });

  setIsLoading(true);
   axios
    .post(CAMPAIGN_LIST_BY_CAMPAGIN, payload)
    .then((res) => {
      datacount.push(res?.data?.message[0].SENT)
      datacount.push(res?.data?.message[0].DELIVER)
      datacount.push(res?.data?.message[0].FAILED)
      datacount.push(res?.data?.message[0].READBY)
      setGraph(res?.data?.message[0])
    //setCampaginList(res.data)
      setIsLoading(false);
      console.log(datacount);
    })
    .catch((err) => {
      let options = {};
      options = {
        place: "tr",
        message: err?.response?.data?.message || "Unable to reach",
        type: "warning",

        autoDismiss: 3,
      };
      notificationAlertRef.current.notificationAlert(options);
      setIsLoading(false);
    });

 }

 
  const datagraph = {
    labels: [ "Sent", "Delivered", "Failed", "Read"],
    datasets: [
      {
        label: "Count",
        data: datacount,
        backgroundColor:["rgba(99,149,194,1)","rgba(118,166,97,1)","rgba(241,194,50,1)","rgba(244,67,54,1)"],
        borderColor: "rgba(75,192,192,1)",
        borderWidth: 1
      }
    ]
  };

  const optionsgraph = {
    responsive: true,
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: false,
        text: "Monthly Sales Bar Chart"
      }
    }
  };

  const submitHandler = async () => {
    console.log("submitHandler");
    const isValid = validatedate();
    setErrorHandle(isValid);
    if (Object.keys(isValid).length == 0) {
      let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
      let todate = moment(search.todate).format("YYYY-MM-DD");

      let lclstrg = localStorage.getItem("user");
      let user = JSON.parse(lclstrg);

      const payload = {
        fromdate: fromdate,
        todate: todate,
        senderid: user.sender_id,
        
      };

      setIsLoading(true);
      await axios
        .post(CAMPAIGN_LIST, payload)
        .then((res) => {
          console.log("res===>",res);
        setCampaginList(res.data)
          setIsLoading(false);
        })
        .catch((err) => {
          let options = {};
          options = {
            place: "tr",
            message: err?.response?.data?.message || "Unable to reach",
            type: "warning",

            autoDismiss: 3,
          };
          notificationAlertRef.current.notificationAlert(options);
          setIsLoading(false);
        });
    }
  };
  const validatedate = () => {
    let errors = {};
    if (!search.fromdate) {
      errors.fromdate = "Please Select From Date";
    }
    if (!search?.todate) {
      errors.todate = "Please Select To Date";
    }

    return errors;
  };

  const toDatevalidation = async (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
      const payload = {
        fromdate: fromdate,
        todate: todate,
        senderid: user?.sender_id,
        client_id: user?.client,
        channel: "whatsapp",
      };

      await axios
        .post(WHATSAPP_CAMPAIGN_LIST_DATE, payload)
        .then((res) => {
          console.log(res?.data.message);
          res?.data?.message?.map((item, index) => {
            campaigns.push({ label: item.campaign, value: item.campaign });
          });
        })
        .catch((err) => {
          let options = {};
          options = {
            place: "tr",
            message: err?.response?.data?.message || "Unable to reach",
            type: "warning",

            autoDismiss: 3,
          };
          notificationAlertRef.current.notificationAlert(options);
          setIsLoading(false);
        });
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };

  var valid = function (current) {
    var yesterday = moment().subtract(0, "day");

    return current.isBefore(yesterday);
  };
  return (
    <>
      <div className="content pb-0">
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <NotificationAlert ref={notificationAlertRef} />
                <Row>
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                      }}
                      isValidDate={valid}
                    />
                    <span style={{ color: "red" }}>
                      {errorhandle?.fromdate}
                    </span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        toDatevalidation(val._d);
                      }}
                      isValidDate={valid}
                    />
                    <span style={{ color: "red" }}>{errorhandle?.todate}</span>
                    <span style={{ color: "red" }}>{validate?.message}</span>
                  </Col>

                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitHandler()}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
              <CardBody className="mb-0">
                <LoadingScreen
                  children=""
                  loading={isLoading}
                  bgColor="rgba(0,0,0,0.7)"
                  spinnerColor="#9ee5f8"
                  textColor="#676767"
                  logoSrc={logo}
                  text="Loading..."
                ></LoadingScreen>
                <Row>
                  <Col sm="3" md="3">
                    <div style={{ overflowY: "scroll", height:"450px" }}>
                      <ul>
                        {campaignList?.message?.map((item, id) => {
                          return (
                            <>
                              {" "}
                              <li
                                style={{
                                  marginBottom: 20,
                                  marginRight: 10,
                                 // border: "1px solid gray",
                                 
                                  borderRadius: 10,
                                  padding: 10,
                                  fontSize: 14,
                                  listStyleType: "none",
                                  background:"#f3f6f4"
                                }}
                                onClick={()=>fetchgraph(item?.sdate,item?.tname,item?.stime)}
                              >
                                <div>{item?.campaign}</div>
                                <div style={{fontSize:"10px"}}>record_count : {item?.record_count} | template: {item?.tname} |  date_time : {item?.sdate} {item?.stime}</div>

                                
                              </li>
                              {/* <li style={{listStyleType:"none"}}>Total Count {item?.count}</li> */}
                            </>
                          );
                        })}
                      </ul>
                    </div>
                  </Col>
                  <Col
                    sm="9"
                    md="9"
                    
                  >
                    <Row >
                      {/* SHOW ONLY ONCE */}
                      {startedOn?.sdate && (
                        <Col md="12" className="d-flex justify-content-between align-items-center">
                          <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Started_On: {startedOn.sdate} {startedOn.stime}
                          </div>

                          <Button type='button' data-placement="top" id="tooltipexcel" class="btn-primary btn-simple btn-icon btn-round  btn-icon mt-4 pull-right btn btn-primary" onClick={downloadCampaignDetails}>
                            <i class="tim-icons icon-cloud-download-93"></i>
                          </Button>
                        </Col>
                      )}
                     
                      {
                        graph&&Object.keys(graph)?.map((item)=>{
                          return   <Col lg="2" md="2" className="pl-1 pr-1">
                                                   
                          <Card className="card-stats box-2 mb-1">
                            <CardBody>
                              <div>
                                <p >{item}</p>
                              </div>
                              <div>
                                <p >{graph[item]} </p>
                              </div>
                              <div>
                              <Progress max={graph["sent"]} value={graph[item]} color={item=="SENT"?"blue":item=="DELIVER"?"green":item=="FAILED"?"yellow":"red"}/>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        })
                      }
                    </Row>
                    <Row>
                      {console.log("----",datacount)}
                      {
                        datacount?.length>0&&<div style={{ width: "600px" }}>
                        <Bar data={datagraph} options={optionsgraph} />
                      </div>
                      }
 
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default withRouter(CampaignReports);
